/**
 * Created by intellicar-sunny on 4/07/20.
 */
import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import momentTZ from "moment-timezone";

export const changeToHours = (dur) => {
  if (!dur) return "--";
  // get hours & multiply fractional part by 60 to get minutes
  let hrs = dur / 60;
  let min = parseInt((hrs % 1) * 60, 10);
  hrs = parseInt(hrs, 10);
  let els = min + " min";
  if (hrs > 0) els = hrs + " hrs " + els;
  return els;
};

const schema = {
  key: "aggregated_report",
  name: "Fleet Insights",
  toolbar: [],
  content: [
    {
      key: "aggregated_report",
      name: "Fleet Insights",
      type: schemaTypes.AGGREGATED_REPORT,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
    },
  ],
};
export default schema;
